import React from "react";
export const LayoutContext = React.createContext({ contentHeight: 200 });
